import { IKnmStatus } from 'APIPackage/CatalogsModule/interfaces/IKnmStatus';

import { IKnmStatusSelectOption } from '../interfaces/IKnmStatusSelectOption';

export const createKnmStatusesOption = (status: IKnmStatus): IKnmStatusSelectOption => ({
  ...status,
  label: status.name,
  value: status.code,
  generalIds: [],
  generalsNames: [],
});
